import React from 'react';
import { Navigate } from 'react-router-dom';
import LoadingOverlay from './LoadingOverlay';
import { usePlatformAdmin } from '../utils/platformAdmin';

// UI gate only — every /api/admin endpoint enforces PlatformAdminGuard itself.
const AdminRoute = ({ children }) => {
    const isAdmin = usePlatformAdmin();
    if (isAdmin === null) return <LoadingOverlay />;
    return isAdmin ? children : <Navigate to="/space" replace />;
};

export default AdminRoute;
